<template>
    <div class="estudiante-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="750" scrollable>
                    <v-card>
                        <v-toolbar card prominent color="primary" dark dense>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa fa-close</v-icon>
                            </v-btn>
                            <template slot="extension">
                                <v-tabs color="primary darken-1" dark grow slider-color="yellow" v-model="activeTab">
                                    <v-tab :key="1" :href="`#tab-1`">
                                        Generales
                                    </v-tab>
                                    <v-tab :key="2" :href="`#tab-2`">
                                        Estudiante
                                    </v-tab>
                                    <v-tab :key="3" :href="`#tab-3`">
                                        Familiares
                                    </v-tab>
                                    <v-tab :key="4" :href="`#tab-4`">
                                        Médicos
                                    </v-tab>
                                    <v-tab :key="5" :href="`#tab-5`">
                                        Anexos
                                    </v-tab>
                                    <v-tab :key="6" :href="`#tab-6`">
                                        Recibos del colegio
                                    </v-tab>
                                </v-tabs>
                            </template>
                        </v-toolbar>
                        <v-flex>
                            <div slot="widget-content">
                                <v-alert
                                    v-model="showErrorAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    Existen errores de validación, revise los datos e intente nuevamente
                                </v-alert>
                                <v-alert
                                    v-model="showErrorDataLoadedAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    No se han podido cargar todos los datos necesarios para este formulario, intente
                                    cargar el formulario nuevamente.
                                </v-alert>
                            </div>
                        </v-flex>
                        <v-card-text>
                            <v-form ref="estudianteForm" v-model="validEstudiante">
                                <v-tabs-items v-model="activeTab">
                                    <v-tab-item :key="1" :value="`tab-1`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm4>
                                                    <v-text-field
                                                        v-model="estudianteItem.nombre"
                                                        label="Nombre*"
                                                        :rules="nombreRules"
                                                        :error-messages="nombreErrors"
                                                        @blur="nombreErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <v-text-field
                                                        v-model="estudianteItem.apellido_paterno"
                                                        label="Apellido paterno*"
                                                        :rules="apellido_paternoRules"
                                                        :error-messages="apellido_paternoErrors"
                                                        @blur="apellido_paternoErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <v-text-field
                                                        v-model="estudianteItem.apellido_materno"
                                                        label="Apellido materno*"
                                                        :rules="apellido_maternoRules"
                                                        :error-messages="apellido_maternoErrors"
                                                        @blur="apellido_maternoErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-menu
                                                        ref="menuFechaNacido"
                                                        v-model="menuFechaNacido"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        lazy
                                                        transition="scale-transition"
                                                        offset-y
                                                        full-width
                                                        min-width="290px"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                v-model="computedFechaNacidoFormatted"
                                                                label="Fecha de nacimiento*"
                                                                v-on="on"
                                                                readonly
                                                                :error-messages="fecha_nacimientoErrors"
                                                                @blur="
                                                                    dateFecha_nacido = parseDate(
                                                                        estudianteItem.fecha_nacido
                                                                    )
                                                                "
                                                            >
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="dateFecha_nacido"
                                                            no-title
                                                            scrollable
                                                            locale="es-es"
                                                            @input="menuFechaNacido = false"
                                                        >
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="estudianteItem.sexo_id"
                                                        :items="SEXOS"
                                                        label="Sexo*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="sexoRules"
                                                        :error-messages="sexoErrors"
                                                        @blur="sexoErrors = []"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showSexoForm = true"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="estudianteItem.peso"
                                                        label="Peso"
                                                        suffix="kg"
                                                        mask="###"
                                                        :error-messages="pesoErrors"
                                                        @blur="pesoErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="estudianteItem.estatura"
                                                        label="Estatura"
                                                        mask="###"
                                                        suffix="cm"
                                                        :error-messages="estaturaErrors"
                                                        @blur="estaturaErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <label for="file" class="v-btn" style="cursor: pointer">
                                                        <v-icon class="pr-1">fa fa-cloud-upload</v-icon> Imagen
                                                    </label>
                                                    <input
                                                        ref="file"
                                                        id="file"
                                                        type="file"
                                                        @change="onChangeFileUpload()"
                                                        accept="image/*"
                                                    />
                                                    <br />
                                                    <div class="error_message">
                                                        {{ fotoFileErrors[0] }}
                                                    </div>
                                                    {{
                                                        estudianteItem.foto.length === 0
                                                            ? "Seleccione una imagen..."
                                                            : estudianteItem.foto.name
                                                    }}
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="2" :value="`tab-2`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm4>
                                                    <v-text-field
                                                        v-model="estudianteItem.matricula"
                                                        label="Matrícula*"
                                                        :rules="matriculaRules"
                                                        :error-messages="matriculaErrors"
                                                        @blur="matriculaErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <v-menu
                                                        ref="menuFechaAlta"
                                                        v-model="menuFechaAlta"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        lazy
                                                        transition="scale-transition"
                                                        offset-y
                                                        full-width
                                                        min-width="290px"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                v-model="computedFechaAltaFormatted"
                                                                label="Fecha de alta"
                                                                v-on="on"
                                                                readonly
                                                                clearable
                                                                :error-messages="fecha_altaErrors"
                                                                @blur="
                                                                    dateFecha_alta = parseDate(
                                                                        estudianteItem.fecha_alta
                                                                    )
                                                                "
                                                            >
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="dateFecha_alta"
                                                            no-title
                                                            scrollable
                                                            locale="es-es"
                                                            @input="menuFechaAlta = false"
                                                        >
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <v-menu
                                                        ref="menuFechaBaja"
                                                        v-model="menuFechaBaja"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        lazy
                                                        transition="scale-transition"
                                                        offset-y
                                                        full-width
                                                        min-width="290px"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                v-model="computedFechaBajaFormatted"
                                                                label="Fecha de baja"
                                                                v-on="on"
                                                                readonly
                                                                clearable
                                                                :error-messages="fecha_bajaErrors"
                                                                @blur="
                                                                    dateFecha_baja = parseDate(
                                                                        estudianteItem.fecha_baja
                                                                    )
                                                                "
                                                            >
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="dateFecha_baja"
                                                            no-title
                                                            scrollable
                                                            locale="es-es"
                                                            @input="menuFechaBaja = false"
                                                        >
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="estudianteItem.escuela_procedencia"
                                                        label="Escuela de procedencia"
                                                        :error-messages="escuela_procendenciaErrors"
                                                        @blur="escuela_procendenciaErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="estudianteItem.tipo_transporte_escolar"
                                                        :items="[
                                                            { nombre: 'Transporte escolar', id: 1 },
                                                            { nombre: 'Vienen por él', id: 2 },
                                                            { nombre: 'Se va solo', id: 3 },
                                                            { nombre: 'Otra opción', id: 4 }
                                                        ]"
                                                        label="Transporte escolar"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :error-messages="transporte_escolarErrors"
                                                        @change="transporte_escolarErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm12 v-if="estudianteItem.tipo_transporte_escolar === 4">
                                                    <v-text-field
                                                        v-model="estudianteItem.tipo_transporte_escolar_otro"
                                                        label="Especifíque el transporte"
                                                        :rules="transporte_escolar_otroRules"
                                                        :error-messages="transporte_escolar_otroErrors"
                                                        @blur="transporte_escolar_otroErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12>
                                                    <v-text-field
                                                        v-model="estudianteItem.domicilio"
                                                        label="Domicilio"
                                                        :error-messages="domicilioErrors"
                                                        @blur="domicilioErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="3" :value="`tab-3`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-autocomplete
                                                        v-model="estudianteItem.padre_id"
                                                        :items="TUTORES"
                                                        label="Padre"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :filter="customFilter"
                                                        append-outer-icon="add"
                                                        :error-messages="padre_idErrors"
                                                        @change="padre_idErrors = []"
                                                        @click:append-outer="showTutorForm = true"
                                                    >
                                                        <template v-slot:item="data">
                                                            <v-list-tile-content>
                                                                <v-list-tile-title
                                                                    v-html="
                                                                        data.item.nombre +
                                                                            ' ' +
                                                                            data.item.apellido_paterno +
                                                                            ' ' +
                                                                            data.item.apellido_materno
                                                                    "
                                                                >
                                                                </v-list-tile-title>
                                                            </v-list-tile-content>
                                                        </template>
                                                        <template v-slot:selection="data">
                                                            {{
                                                                data.item.nombre +
                                                                    " " +
                                                                    data.item.apellido_paterno +
                                                                    " " +
                                                                    data.item.apellido_materno
                                                            }}
                                                        </template>
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-autocomplete
                                                        v-model="estudianteItem.madre_id"
                                                        :items="TUTORES"
                                                        label="Madre"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :filter="customFilter"
                                                        append-outer-icon="add"
                                                        :error-messages="madre_idErrors"
                                                        @change="madre_idErrors = []"
                                                        @click:append-outer="showTutorForm = true"
                                                    >
                                                        <template v-slot:item="data">
                                                            <v-list-tile-content>
                                                                <v-list-tile-title
                                                                    v-html="
                                                                        data.item.nombre +
                                                                            ' ' +
                                                                            data.item.apellido_paterno +
                                                                            ' ' +
                                                                            data.item.apellido_materno
                                                                    "
                                                                >
                                                                </v-list-tile-title>
                                                            </v-list-tile-content>
                                                        </template>
                                                        <template v-slot:selection="data">
                                                            {{
                                                                data.item.nombre +
                                                                    " " +
                                                                    data.item.apellido_paterno +
                                                                    " " +
                                                                    data.item.apellido_materno
                                                            }}
                                                        </template>
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="estudianteItem.cantidad_hermanos"
                                                        label="Cantidad de hermanos"
                                                        mask="###"
                                                        :error-messages="cantidad_hermanosErrors"
                                                        @blur="cantidad_hermanosErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="estudianteItem.convive_con"
                                                        :items="[
                                                            { text: 'Madre', value: 1 },
                                                            { text: 'Padre', value: 2 },
                                                            { text: 'Madre y Padre', value: 3 },
                                                            { text: 'Ninguno', value: 0 }
                                                        ]"
                                                        label="Convivie con"
                                                        :error-messages="convive_conErrors"
                                                        @blur="convive_conErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="estudianteItem.cantidad_habitantes"
                                                        label="Habitantes con los que convive"
                                                        mask="###"
                                                        :error-messages="cant_habitantesErrors"
                                                        @blur="cant_habitantesErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="4" :value="`tab-4`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="estudianteItem.estado_nutricional"
                                                        :items="[
                                                            { text: 'Nutrición normal', value: 1 },
                                                            { text: 'Desnutrición moderada', value: 2 },
                                                            { text: 'Desnutrición severa', value: 3 }
                                                        ]"
                                                        label="Estado nutrición"
                                                        :error-messages="estado_nutricionalErrors"
                                                        @blur="estado_nutricionalErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="estudianteItem.tipo_sangre_id"
                                                        :items="SANGRES"
                                                        label="Tipo de sangre"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showSangreForm = true"
                                                        :error-messages="tipo_sngreErrors"
                                                        @blur="tipo_sngreErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="estudianteItem.servicio_medico_id"
                                                        :items="SERVICIOS"
                                                        label="Servicio médico"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showServicioForm = true"
                                                        :error-messages="servicio_medicoErrors"
                                                        @blur="servicio_medicoErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6 v-if="estudianteItem.servicio_medico_id === 4">
                                                    <v-text-field
                                                        v-model="estudianteItem.servicio_medico_otro"
                                                        label="Especifíquelo"
                                                        :rules="servicio_medico_otroRules"
                                                        :error-messages="servicio_medico_otroErrors"
                                                        @blur="servicio_medico_otroErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="estudianteItem.agudeza_visual"
                                                        :items="[
                                                            { text: 'Normal', value: 1 },
                                                            { text: 'Disminuída', value: 2 },
                                                            { text: 'Usa lentes', value: 3 }
                                                        ]"
                                                        label="Agudeza visual"
                                                        :error-messages="agudeza_visualErrors"
                                                        @blur="agudeza_visualErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm12>
                                                    <v-combobox
                                                        v-model="estudianteItem.alergias"
                                                        :items="[
                                                            'Asma',
                                                            'Rinitis',
                                                            'Conjutivitis',
                                                            'Dermatitis',
                                                            'Urticaria',
                                                            'Alimentos',
                                                            'Medicamentos',
                                                            'Picaduras de insectos'
                                                        ]"
                                                        hide-selected
                                                        label="Alergias"
                                                        multiple
                                                        persistent-hint
                                                        deletable-chips
                                                        small-chips
                                                        clearable
                                                        :error-messages="alergiasErrors"
                                                        @change="alergiasErrors = []"
                                                    >
                                                    </v-combobox>
                                                </v-flex>
                                                <v-flex xs12 sm12>
                                                    <v-combobox
                                                        v-model="estudianteItem.padecimientos"
                                                        :items="[
                                                            'Enfermedades cardiovasculares',
                                                            'Obesidad',
                                                            'Diabetes',
                                                            'Cáncer',
                                                            'EPOC',
                                                            'Gripe',
                                                            'Enfermedades hepáticas',
                                                            'Estrés'
                                                        ]"
                                                        hide-selected
                                                        label="Padecimientos"
                                                        multiple
                                                        persistent-hint
                                                        deletable-chips
                                                        small-chips
                                                        clearable
                                                        :error-messages="padecimientosErrors"
                                                        @change="padecimientosErrors = []"
                                                    >
                                                    </v-combobox>
                                                </v-flex>
                                                <v-flex xs12 sm12>
                                                    <v-combobox
                                                        v-model="estudianteItem.medicamentos"
                                                        :items="[
                                                            'Alprenolol',
                                                            'Hidralazina',
                                                            'Isoproterenol',
                                                            'Lidocaina',
                                                            'Meperidina',
                                                            'Morfina',
                                                            'Nifedipina',
                                                            'Nitroglicerina',
                                                            'Propanolol',
                                                            'Testoterona',
                                                            'Verapamilo'
                                                        ]"
                                                        hide-selected
                                                        label="Medicamentos"
                                                        multiple
                                                        persistent-hint
                                                        deletable-chips
                                                        small-chips
                                                        clearable
                                                        :error-messages="medicamentosErrors"
                                                        @change="medicamentosErrors = []"
                                                    >
                                                    </v-combobox>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="5" :value="`tab-5`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-label>Acta de nacimiento</v-label>
                                                    <v-radio-group v-model="estudianteItem.ractanacido" row>
                                                        <v-radio label="No" :value="1" key="1"></v-radio>
                                                        <v-radio label="Original" :value="2" key="2"></v-radio>
                                                        <v-radio label="Copia" :value="3" key="3"></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-label>Certificado de primaria</v-label>
                                                    <v-radio-group v-model="estudianteItem.rcertificado_primaria" row>
                                                        <v-radio label="No" :value="1" key="1"></v-radio>
                                                        <v-radio label="Original" :value="2" key="2"></v-radio>
                                                        <v-radio label="Copia" :value="3" key="3"></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-label>Boleta de primer año</v-label>
                                                    <v-radio-group v-model="estudianteItem.rboleta_primer_anyo" row>
                                                        <v-radio label="No" :value="1" key="1"></v-radio>
                                                        <v-radio label="Original" :value="2" key="2"></v-radio>
                                                        <v-radio label="Copia" :value="3" key="3"></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-label>Boleta de segundo año</v-label>
                                                    <v-radio-group v-model="estudianteItem.rboleta_segundo_anyo" row>
                                                        <v-radio label="No" :value="1" key="1"></v-radio>
                                                        <v-radio label="Original" :value="2" key="2"></v-radio>
                                                        <v-radio label="Copia" :value="3" key="3"></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-label>Constancia de examen</v-label>
                                                    <v-radio-group v-model="estudianteItem.rconstancia_examen" row>
                                                        <v-radio label="No" :value="1" key="1"></v-radio>
                                                        <v-radio label="Original" :value="2" key="2"></v-radio>
                                                        <v-radio label="Copia" :value="3" key="3"></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-checkbox
                                                        v-model="estudianteItem.rcarta_buena_conducta"
                                                        label="Carta de buena conducta"
                                                    >
                                                    </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <v-checkbox
                                                        v-model="estudianteItem.rcarta_no_adeudo"
                                                        label="Carta de no adeudo"
                                                    >
                                                    </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <v-checkbox
                                                        v-model="estudianteItem.rexamen_medico"
                                                        label="Examen médico"
                                                    >
                                                    </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <v-checkbox v-model="estudianteItem.rcurp" label="CURP">
                                                    </v-checkbox>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="6" :value="`tab-6`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-checkbox v-model="estudianteItem.rcontrato" label="Contrato">
                                                    </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-checkbox
                                                        v-model="estudianteItem.raviso_privacidad"
                                                        label="Aviso de privacidad"
                                                    >
                                                    </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-checkbox
                                                        v-model="estudianteItem.rfecha_inscripcion"
                                                        label="Ficha de inscripción"
                                                    >
                                                    </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-checkbox v-model="estudianteItem.rreglamento" label="Reglamento">
                                                    </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-checkbox
                                                        v-model="estudianteItem.rhoja_informes"
                                                        label="Hoja de informes"
                                                    >
                                                    </v-checkbox>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <small class="ml-2">(*) indica campos requeridos</small>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
        <sexo-form
            v-if="showSexoForm"
            form-title="Nuevo sexo"
            :initial-item="null"
            @formCanceled="showSexoForm = false"
        >
        </sexo-form>
        <tutor-form
            v-if="showTutorForm"
            form-title="Nuevo tutor"
            :initial-item="null"
            @formCanceled="showTutorForm = false"
        >
        </tutor-form>
        <tipo-sangre-form
            v-if="showSangreForm"
            form-title="Nuevo Tipo de sangre"
            :initial-item="null"
            @formCanceled="showSangreForm = false"
        >
        </tipo-sangre-form>
        <servicio-medico-form
            v-if="showServicioForm"
            form-title="Nuevo Servicio médico"
            :initial-item="null"
            @formCanceled="showServicioForm = false"
        >
        </servicio-medico-form>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Util from "@/util"
const SexoForm = () => import("@/components/personal/nomencladores/sexo-form/sexo-form")
const TipoSangreForm = () => import("@/components/cobranza/nomencladores/tipo-sangre-form/tipo-sangre-form")
const TutorForm = () => import("@/components/cobranza/tutor/tutor-form")
const ServicioMedicoForm = () => import("@/components/cobranza/nomencladores/servicio-medico-form/servicio-medico-form")

export default {
    components: {
        ServicioMedicoForm,
        TutorForm,
        TipoSangreForm,
        SexoForm
    },
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null }
    },
    data() {
        return {
            activeTab: "tab-1",
            loading: false,
            validEstudiante: false,
            estudianteItem: {
                matricula: "",
                nombre: "",
                apellido_paterno: "",
                apellido_materno: "",
                foto: [],
                fecha_nacido: this.formatDate(new Date().toISOString().substr(0, 10)),
                sexo_id: "",
                fecha_alta: this.formatDate(new Date().toISOString().substr(0, 10)),
                fecha_baja: this.formatDate(new Date().toISOString().substr(0, 10)),
                escuela_procedencia: "",
                cantidad_hermanos: "",
                padre_id: "",
                madre_id: "",
                tipo_transporte_escolar: "",
                tipo_transporte_escolar_otro: "",
                domicilio: "",
                estado_nutricional: "",
                tipo_sangre_id: "",
                servicio_medico_id: "",
                servicio_medico_otro: "",
                agudeza_visual: "",
                convive_con: "",
                cantidad_habitantes: "",
                estatura: "",
                peso: "",
                alergias: "",
                padecimientos: "",
                medicamentos: "",
                ractanacido: 1,
                rcarta_buena_conducta: "",
                rcarta_no_adeudo: "",
                rcertificado_primaria: 1,
                rboleta_primer_anyo: 1,
                rboleta_segundo_anyo: 1,
                rconstancia_examen: 1,
                rexamen_medico: "",
                rcurp: "",
                rcontrato: "",
                raviso_privacidad: "",
                rfecha_inscripcion: "",
                rreglamento: "",
                rhoja_informes: ""
            },

            //menus de fecha
            menuFechaNacido: false,
            menuFechaAlta: false,
            menuFechaBaja: false,
            dateFecha_nacido: new Date().toISOString().substr(0, 10),
            dateFecha_alta: new Date().toISOString().substr(0, 10),
            dateFecha_baja: "",

            //formularios de los nomencladores
            showSexoForm: false,
            showTutorForm: false,
            showSangreForm: false,
            showServicioForm: false,

            //alert errores de validacion
            showErrorAlert: false,

            //validaciones
            nombreRules: [v => !!v || "Debe proporcionar un nombre"],
            nombreErrors: [],
            apellido_paternoRules: [v => !!v || "Debe proporcionar un apellido paterno"],
            apellido_paternoErrors: [],
            apellido_maternoRules: [v => !!v || "Debe proporcionar un apellido materno"],
            apellido_maternoErrors: [],
            fecha_nacimientoRules: [v => !!v || "Debe proporcionar una fecha de nacimiento"],
            fecha_nacimientoErrors: [],
            sexoRules: [v => !!v || "Debe proporcionar un sexo"],
            sexoErrors: [],
            pesoErrors: [],
            estaturaErrors: [],
            matriculaRules: [v => !!v || "Debe proporcionar una matrícula"],
            matriculaErrors: [],
            fecha_altaErrors: [],
            fecha_bajaErrors: [],
            escuela_procendenciaErrors: [],
            domicilioErrors: [],
            padre_idErrors: [],
            madre_idErrors: [],
            cantidad_hermanosErrors: [],
            convive_conErrors: [],
            cant_habitantesErrors: [],
            estado_nutricionalErrors: [],
            tipo_sngreErrors: [],
            servicio_medicoErrors: [],
            servicio_medico_otroRules: [v => !!v || "Debe especificar el servicio médico"],
            servicio_medico_otroErrors: [],
            transporte_escolarErrors: [],
            transporte_escolar_otroRules: [v => !!v || "Debe especificar el transporte"],
            transporte_escolar_otroErrors: [],
            agudeza_visualErrors: [],
            alergiasErrors: [],
            padecimientosErrors: [],
            medicamentosErrors: [],
            fotoFileErrors: [],

            //saber si se cargaron todos los datos necesarios para el formulario
            showErrorDataLoadedAlert: false
        }
    },
    computed: {
        ...mapGetters(["SEXOS", "SANGRES", "TUTORES", "SERVICIOS"]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || !this.validEstudiante || this.fotoFileErrors.length > 0
        },

        computedFechaNacidoFormatted: {
            get: function() {
                return this.formatDate(this.dateFecha_nacido)
            },
            set: function() {
                return (this.estudianteItem.fecha_nacido = "")
            }
        },

        computedFechaAltaFormatted: {
            get: function() {
                return this.formatDate(this.dateFecha_alta)
            },
            set: function() {
                return (this.estudianteItem.fecha_alta = "")
            }
        },

        computedFechaBajaFormatted: {
            get: function() {
                return this.formatDate(this.dateFecha_baja)
            },
            set: function() {
                return (this.estudianteItem.fecha_baja = "")
            }
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.estudianteForm.validate()
            if (this.validEstudiante) {
                let estudiante = new FormData()

                Object.entries(this.estudianteItem).forEach(([key, value]) => {
                    estudiante.append(key, value)
                })

                estudiante.append("estado", this.estudianteItem.estado ? 1 : 0)
                estudiante.append("ractanacido", this.estudianteItem.ractanacido)
                estudiante.append("rcarta_buena_conducta", this.estudianteItem.rcarta_buena_conducta ? 1 : 0)
                estudiante.append("rcarta_no_adeudo", this.estudianteItem.rcarta_no_adeudo ? 1 : 0)
                estudiante.append("rcertificado_primaria", this.estudianteItem.rcertificado_primaria)
                estudiante.append("rboleta_primer_anyo", this.estudianteItem.rboleta_primer_anyo)
                estudiante.append("rboleta_segundo_anyo", this.estudianteItem.rboleta_segundo_anyo)
                estudiante.append("rconstancia_examen", this.estudianteItem.rconstancia_examen)
                estudiante.append("rexamen_medico", this.estudianteItem.rexamen_medico ? 1 : 0)
                estudiante.append("rcurp", this.estudianteItem.rcurp ? 1 : 0)
                estudiante.append("rcontrato", this.estudianteItem.rcontrato ? 1 : 0)
                estudiante.append("raviso_privacidad", this.estudianteItem.raviso_privacidad ? 1 : 0)
                estudiante.append("rfecha_inscripcion", this.estudianteItem.rfecha_inscripcion ? 1 : 0)
                estudiante.append("rreglamento", this.estudianteItem.rreglamento ? 1 : 0)
                estudiante.append("rhoja_informes", this.estudianteItem.rhoja_informes ? 1 : 0)

                if (this.estudianteItem.foto !== "") {
                    estudiante.append("Estudiante[file]", this.estudianteItem.foto)
                }

                this.$store
                    .dispatch(this.isNewRecord ? "ADD_ESTUDIANTE" : "UPDATE_ESTUDIANTE", estudiante)
                    .then(result => {
                        if (!result) {
                            this.loading = false
                        }
                        if (result === null || result.status === 404 || result.status === 500) {
                            //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe o no hay coneccion con el servidor
                            this.$emit("formCanceled")
                        } else {
                            // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                            let { data, status } = result
                            if (status === 422) {
                                this.showErrorAlert = true
                                data.forEach(error => {
                                    switch (error.field) {
                                        case "matricula":
                                            this.matriculaErrors.push(error.message)
                                            break
                                        case "nombre":
                                            this.nombreFieldErrors.push(error.message)
                                            break
                                        case "apellido_paterno":
                                            this.apellido_paternoFieldErrors.push(error.message)
                                            break
                                        case "apellido_materno":
                                            this.apellido_maternoFieldErrors.push(error.message)
                                            break
                                        case "fecha_nacido":
                                            this.fecha_nacimientoErrors.push(error.message)
                                            break
                                        case "sexo_id":
                                            this.sexoErrors.push(error.message)
                                            break
                                        case "escuela_procedencia":
                                            this.escuela_procendenciaErrors.push(error.message)
                                            break
                                        case "cantidad_hermanos":
                                            this.cantidad_hermanosErrors.push(error.message)
                                            break
                                        case "convive_con":
                                            this.convive_conErrors.push(error.message)
                                            break
                                        case "padre_id":
                                            this.padre_idErrors.push(error.message)
                                            break
                                        case "madre_id":
                                            this.madre_idErrors.push(error.message)
                                            break
                                        case "domicilio":
                                            this.domicilioErrors.push(error.message)
                                            break
                                        case "estado_nutricional":
                                            this.estado_nutricionalErrors.push(error.message)
                                            break
                                        case "tipo_sangre_id":
                                            this.tipo_sngreErrors.push(error.message)
                                            break
                                        case "servicio_medico_id":
                                            this.servicio_medicoErrors.push(error.message)
                                            break
                                        case "servicio_medico_otro":
                                            this.servicio_medico_otroErrors.push(error.message)
                                            break
                                        case "agudeza_visual":
                                            this.agudeza_visualErrors.push(error.message)
                                            break
                                        case "estatura":
                                            this.estaturaErrors.push(error.message)
                                            break
                                        case "peso":
                                            this.pesoErrors.push(error.message)
                                            break
                                        case "alergias":
                                            this.alergiasErrors.push(error.message)
                                            break
                                        case "padecimientos":
                                            this.padecimientosErrors.push(error.message)
                                            break
                                        case "medicamentos":
                                            this.medicamentosErrors.push(error.message)
                                            break
                                        case "tipo_transporte_escolar":
                                            this.transporte_escolarErrors.push(error.message)
                                            break
                                        case "tipo_transporte_escolar_otro":
                                            this.transporte_escolar_otroErrors.push(error.message)
                                            break
                                        case "fecha_alta":
                                            this.fecha_altaErrors.push(error.message)
                                            break
                                        case "fecha_baja":
                                            this.fecha_bajaErrors.push(error.message)
                                            break
                                        default:
                                            console.log(error.message)
                                    }
                                })
                            }
                        }
                        this.loading = false
                    })
            } else {
                this.loading = false
            }
        },

        cancelForm() {
            this.$emit("formCanceled")
        },

        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split("-")
            return `${day}/${month}/${year}`
        },

        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split("/")
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
        },

        onChangeFileUpload() {
            this.estudianteItem.foto = this.$refs.file.files[0]
            if (this.estudianteItem.foto !== [] && Util.validateFile(this.estudianteItem.foto.name, ["image"])) {
                this.fotoFileErrors = []
            } else {
                this.estudianteItem.foto = []
                this.fotoFileErrors.push("El archivo seleccionado debe ser una imagen")
            }
        },

        customFilter(item, queryText) {
            const textNombre = item.nombre.toLowerCase()
            const textApellidoPaterno = item.apellido_paterno.toLowerCase()
            const textApellidoMaterno = item.apellido_materno.toLowerCase()
            const searchText = queryText.toLowerCase()

            return (
                textNombre.indexOf(searchText) > -1 ||
                textApellidoPaterno.indexOf(searchText) > -1 ||
                textApellidoMaterno.indexOf(searchText) > -1
            )
        }
    },

    watch: {
        dateFecha_nacido: function() {
            this.estudianteItem.fecha_nacido = this.formatDate(this.dateFecha_nacido)
        },

        dateFecha_alta: function() {
            this.estudianteItem.fecha_alta = this.formatDate(this.dateFecha_alta)
        },

        dateFecha_baja: function() {
            this.estudianteItem.fecha_baja = this.formatDate(this.dateFecha_baja)
        }
    },

    mounted() {
        this.$store.dispatch("LOAD_ALL_TUTORES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SEXOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SANGRES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SERVICIOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        if (this.initialItem !== null) {
            // Cargando información del elemento a actualizar
            this.estudianteItem = Object.assign({}, this.initialItem)
            this.estudianteItem.foto = ""

            if (this.initialItem.alergias) {
                this.estudianteItem.alergias = this.initialItem.alergias.split(",")
            } else this.estudianteItem.alergias = []

            if (this.initialItem.medicamentos) {
                this.estudianteItem.medicamentos = this.initialItem.medicamentos.split(",")
            } else this.estudianteItem.medicamentos = []

            if (this.initialItem.padecimientos) {
                this.estudianteItem.padecimientos = this.initialItem.padecimientos.split(",")
            } else this.estudianteItem.padecimientos = []

            if (!this.initialItem.convive_con) {
                this.estudianteItem.convive_con = ""
            }

            if (!this.initialItem.estado_nutricional) {
                this.estudianteItem.estado_nutricional = ""
            }

            if (!this.initialItem.tipo_sangre_id) {
                this.estudianteItem.tipo_sangre_id = ""
            }

            if (!this.initialItem.servicio_medico_id) {
                this.estudianteItem.servicio_medico_id = ""
            }

            if (!this.initialItem.agudeza_visual) {
                this.estudianteItem.agudeza_visual = ""
            }

            if (!this.initialItem.tipo_transporte_escolar) {
                this.estudianteItem.tipo_transporte_escolar = ""
            }

            if (this.initialItem.foto && this.initialItem.foto.length) {
                this.estudianteItem.foto = { name: this.initialItem.foto }
            }

            if (this.initialItem.fecha_nacido) {
                let [dia, mes, ano] = this.initialItem.fecha_nacido.split("/")
                this.estudianteItem.fecha_nacido = ano + "-" + mes + "-" + dia
                this.dateFecha_nacido = this.estudianteItem.fecha_nacido
            }

            if (this.initialItem.fecha_alta) {
                let [dia, mes, ano] = this.initialItem.fecha_alta.split("/")
                this.estudianteItem.fecha_alta = ano + "-" + mes + "-" + dia
                this.dateFecha_alta = this.estudianteItem.fecha_alta
            }

            if (this.initialItem.fecha_baja) {
                let [dia, mes, ano] = this.initialItem.fecha_baja.split("/")
                this.estudianteItem.fecha_baja = ano + "-" + mes + "-" + dia
                this.dateFecha_baja = this.estudianteItem.fecha_baja
            }
        }
    }
}
</script>

<style scoped>
.v-alert {
    padding-top: 3px;
    padding-bottom: 4px;
    margin-top: 1px;
    margin-left: 2px;
    margin-right: 2px;
}

input[type="file"] {
    display: none;
}

.error_message {
    font-size: 12px;
    color: #ff5252;
    caret-color: #ff5252;
}
</style>
